













































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {IAvpPeriod} from '@/entities/avp-periods/avp-period.interface';

@Component({})
export default class AvpPaySchedule extends Vue {
    @Prop({ default: null }) public periods: IAvpPeriod[];
    @Prop({ default: false }) public viewPayoutPhp: boolean;
    @Prop({ default: false }) public viewPayoutDollars: boolean;

    get view(): boolean {
        let view = true;
        if (!this.periods || !this.periods.length) {
            view = false;
        }
        return view;
    }

    private isLastItem(item): boolean {
        return this.periods[this.periods.length - 1] === item;
    }
}
